import { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import { EditCaseDialog } from "./EditCaseDialog";

interface EditCaseButtonProps {
  caseId: string;
}

export const EditCaseButton: FC<EditCaseButtonProps> = ({ caseId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span
        className="text-blue-600 hover:text-blue-600 cursor-pointer hover:underline text-sm font-medium"
        onClick={() => setOpen(true)}
      >
        <FormattedMessage id="editCase" defaultMessage="Edit Case" />
      </span>
      {open && (
        <EditCaseDialog open={open} setOpen={setOpen} projectId={caseId} />
      )}
    </>
  );
};
